import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import {
    OutgoingInvoice,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    data: {id: number},
}

const useCreateCreditNote = (
    onSuccess: (params: OutgoingInvoice) => void,
): UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessCreateCreditNote,
        onError,
    } = useHandleStatusRequest({
        id: 'createCreditNote',
        title: 'Create Credit Note',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            data,
        }: RequestParams) => {
            return simpleApi({
                ...requests.createCreditNoteInvoice({
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessCreateCreditNote,
        onError,
    })
}

export default useCreateCreditNote
